import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ec9b614"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ec9b614')) {
      api.createRecord('4ec9b614', component.options)
    } else {
      api.reload('4ec9b614', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ec9b614", function () {
      api.rerender('4ec9b614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/new-kee-wrap/index.vue"
export default component.exports